import { EEventType } from './../../enums/EEventType';
import styles from './index.module.less';
import template from './index.art';
import OY from '../../types/OY';
import { IOYTagProps, IOYTagState } from './const';
import { jeact } from '../../decorators/jeact';

@jeact()
export default class OYTag extends OY<IOYTagProps, IOYTagState> {
  static displayName = 'OYTag';

  static defaultProps: Partial<IOYTagProps> = {
    value: '',
    size: 'tiny'
  }

  public state: IOYTagState = {
    width: ''
  };

  $node = {}

  preValue: string[] = [];

  render() {
    return template({ props: this.props, state: this.state, styles });
  }

  setNode(): void {
    this.$node = {
    }
  }

  protected bindTagClick() {
    this.$el.click((ev: Event) => {
      if (this.props.allRemoveable) {
        this.eventEmitter.emit(EEventType.onRemove, this.props.value)
      }
    })
  }

  protected bindIconClick() {
    this.$el.find(`.${styles.icon}`).click((ev: Event) => {
      ev.stopPropagation();
      this.eventEmitter.emit(EEventType.onRemove, this.props.value)
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/OYTag/index.ts